import { EnrollmentCharacteristicsInput } from '../../lib/types/models/enrollment-characteristics/enrollment-characteristics-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createEnrollmentCharacteristic(data: EnrollmentCharacteristicsInput) {
  return restApiClient
    .url(constructApiUrl(API.enrollmentCharacteristics.create.url, null))
    .post(data)
}
